import { Link } from "react-router-dom";
import { Droplets, Wrench, Sparkles } from "lucide-react";
import { useSiteCopy } from "@/lib/copy";

const SERVICES = [
  { icon: Wrench, title: "Pool Repair", desc: "Pumps, heaters, filters, salt cells, automation, liners and plaster. Same-week diagnostic visits with transparent quotes — we fix what we can and tell you plainly when something needs replacing." },
  { icon: Sparkles, title: "Pool Cleaning", desc: "Weekly maintenance, seasonal openings and closings, winterizations, safety covers, and lab-grade chemistry programs that protect skin and equipment alike." },
  { icon: Droplets, title: "Pool Upgrades", desc: "Equipment modernization, smart automation, LED lighting, coping and deck renovations, plaster refinishes — bring a tired pool back to its luminous self." },
];

export default function Services() {
  const t = useSiteCopy();
  return (
    <div className="mx-auto max-w-7xl px-5 py-16 md:px-8 md:py-24">
      <div className="max-w-3xl">
        <span className="text-xs font-semibold uppercase tracking-[0.2em] text-cyan-700">{t("services.eyebrow", "Services")}</span>
        <h1 className="mt-2 font-display text-4xl font-bold text-slate-900 md:text-5xl wavy">{t("services.title", "Every part of pool ownership, made simple.")}</h1>
        <p className="mt-4 text-lg text-slate-600">{t("services.subtitle", "From the first design sketch to the last leaf of autumn, we cover the whole arc.")}</p>
      </div>

      <div className="mt-12 grid gap-5 md:grid-cols-2 lg:grid-cols-3">
        {SERVICES.map((s, i) => {
          const Icon = s.icon;
          return (
            <div key={s.title} className="group relative overflow-hidden rounded-2xl border border-cyan-100 bg-white p-7 shadow-sm transition hover:-translate-y-1 hover:shadow-lg" data-testid={`service-page-card-${i}`}>
              <div className="absolute -right-10 -top-10 h-32 w-32 rounded-full bg-cyan-50 transition-transform duration-500 group-hover:scale-110" />
              <Icon className="relative h-8 w-8 text-cyan-600" />
              <h3 className="relative mt-4 font-display text-xl font-bold text-slate-900">{t(`services.card${i + 1}_title`, s.title)}</h3>
              <p className="relative mt-2 text-sm text-slate-600">{t(`services.card${i + 1}_desc`, s.desc)}</p>
            </div>
          );
        })}
      </div>

      <div className="mt-14 rounded-3xl water-gradient p-10 text-white md:p-12">
        <div className="grid items-center gap-6 md:grid-cols-2">
          <div>
            <h2 className="font-display text-3xl font-bold">{t("services.cta_title", "Tell us about your project.")}</h2>
            <p className="mt-2 text-cyan-100/90">{t("services.cta_body", "We'll send a free, friendly quote — usually the same day.")}</p>
          </div>
          <div className="flex md:justify-end">
            <Link to="/quote" className="rounded-full bg-white px-6 py-3 font-medium text-cyan-800 shadow-lg" data-testid="services-cta-quote-button">{t("services.cta_button", "Start a quote →")}</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
